"use client";
import { createSafeContext } from "../../core/utils/create-safe-context/create-safe-context.mjs";
//#region packages/@mantine/core/src/components/Menu/Menu.context.ts
const [MenuContextProvider, useMenuContext] = createSafeContext("Menu component was not found in the tree");
//#endregion
export { MenuContextProvider, useMenuContext };

//# sourceMappingURL=Menu.context.mjs.map